export enum ContactRequestErrorCode {
  NETWORK_ERROR = 'NETWORK_ERROR',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  INVALID_TRANSITION = 'INVALID_TRANSITION',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  UNKNOWN = 'UNKNOWN',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}
